import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '../components/Dashboard.vue'
import Homepage from '../components/Homepage.vue'
import Producers from '../components/Producers.vue'
import ProducerAddEdit from '../components/ProducerAddEdit.vue'
import ProductAddEdit from '../components/ProductAddEdit.vue'
import Records from '../components/Records.vue'
import Products from '../components/Products.vue'
import RecordEdit from '../components/RecordEdit.vue'
import Notices from '../components/Notices.vue'
import NoticeAddEdit from '../components/NoticeAddEdit.vue'
import Regulations from '../components/Regulations.vue'
import PriceList from '../components/PriceList.vue'
import Contact from '../components/Contact.vue'
import Users from '../components/Users.vue'
import ChangePackage from '../components/ChangePackage.vue'
import Payments from '../components/Payments.vue'
import Login from '../components/Login.vue'
import auth from './../auth'
import moment from 'moment'

Vue.use(Router)

function requireAuth (to, from, next) {
  if (!auth.hasToken()) {
    next({
      name: 'Login'
    })
  } else {
    next()
  }
}

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      name: 'Dashboard',
      path: '/',
      component: Dashboard,
      redirect: () => {
        return {
          name: 'Records',
          params: {
            id: moment().format('YYYY-MM-DD')
          }
        }
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (auth.hasToken()) {
          next({
            path: '/'
          })
        } else {
          next()
        }
      }
    },
    {
      path: '/homepage',
      name: 'Homepage',
      component: Homepage,
      beforeEnter: requireAuth
    },
    {
      path: '/producers',
      name: 'Producers',
      component: Producers,
      beforeEnter: requireAuth
    },
    {
      path: '/producers/add',
      name: 'ProducerAdd',
      component: ProducerAddEdit,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '/producers/:id/edit',
      name: 'ProducerEdit',
      component: ProducerAddEdit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/records/list/:id/:search?',
      name: 'Records',
      component: Records,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/products/list',
      name: 'Products',
      component: Products,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/products/create',
      name: 'ProductAdd',
      component: ProductAddEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/records/edit/:id',
      name: 'RecordEdit',
      component: RecordEdit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/notices',
      name: 'Notices',
      component: Notices,
      beforeEnter: requireAuth
    },
    {
      path: '/notices/add',
      name: 'NoticeAdd',
      component: NoticeAddEdit,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '/notices/:id/edit',
      name: 'NoticeEdit',
      component: NoticeAddEdit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/regulations',
      name: 'Regulations',
      component: Regulations,
      beforeEnter: requireAuth
    },
    {
      path: '/price-list',
      name: 'PriceList',
      component: PriceList,
      beforeEnter: requireAuth
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      beforeEnter: requireAuth
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      beforeEnter: requireAuth
    },
    {
      path: '/users/:id/change-package',
      name: 'ChangePackage',
      component: ChangePackage,
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Payments,
      beforeEnter: requireAuth
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js